import { Component, OnInit } from "@angular/core";
import { ItemService } from "../service/item.service";
import { ItemModel } from "../model/itemModel";

@Component({
  selector: "app-update-item",
  templateUrl: "./update-item.component.html",
  styleUrls: ["./update-item.component.css"],
})
export class UpdateItemComponent implements OnInit {
  constructor(private itemService: ItemService) {}

  // Define columns for the PrimeNG table
  cols: any[] = [
    { field: "Id", header: "מזהה", width: "80", priority: "ui-p-6" },
    { field: "ItemName", header: "שם פריט", width: "120", priority: "ui-p-1" },
    { field: "ItemDesc", header: "תיאור", width: "200", priority: "ui-p-1" },
    { field: "ItemId", header: "קוד מוצר", width: "200", priority: "ui-p-1" },
    {
      field: "ItemsIncluded",
      header: "מוצרים כלולים",
      width: "200",
      priority: "ui-p-1",
    },

    {
      field: "OrderNumber",
      header: "מספר הזמנה",
      width: "100",
      priority: "ui-p-2",
    },
    {
      field: "LineNumber",
      header: "מספר שורה",
      width: "120",
      priority: "ui-p-6",
    },
    { field: "SupplierName", header: "ספק", width: "120", priority: "ui-p-6" },
    {
      field: "PurchaseDate",
      header: "תאריך רכישה",
      width: "100",
      priority: "ui-p-2",
    },
    {
      field: "WarrantyDate",
      header: "תוקף אחריות",
      width: "100",
      priority: "ui-p-2",
    },
    { field: "Destination", header: "יעד", width: "100", priority: "ui-p-6" },
    {
      field: "ItemOwnerName",
      header: "בעלים",
      width: "120",
      priority: "ui-p-6",
    },
    {
      field: "ItemOwnerPhone",
      header: "טלפון בעלים",
      width: "120",
      priority: "ui-p-6",
    },
    { field: "Notes", header: "הערות", width: "200", priority: "ui-p-6" },
    {
      field: "ReportBy",
      header: "דווח על ידי",
      width: "150",
      priority: "ui-p-6",
    },
    {
      field: "ReportDate",
      header: "תאריך דיווח",
      width: "100",
      priority: "ui-p-2",
    },

    {
      field: "ReceivedDate",
      header: "תאריך חתימה על קבלת הציוד",
      width: "100",
      priority: "ui-p-2",
    },
  ];

  items: ItemModel[] = [];

  orderNumber: string = "";

  newItem: ItemModel;

  selectedItem: ItemModel;

  isSearched: boolean = false;

  successMessage: string = "";

  errorMessage: string = "";

  itemsList: ItemModel[] = [];

  ngOnInit() {
    this.getAllItems();
  }

  getAllItems() {
    this.itemService.getAllItems().subscribe(
      (response: ItemModel[]) => {
        console.log(response);
        this.items = response;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getOrderDetails = (orderNumber: string) => {
    if (!orderNumber) {
      alert("Please enter an order number");
      return;
    }

    this.isSearched = true;

    this.itemService.getItemByOrderNumber(orderNumber).subscribe(
      (response: ItemModel[]) => {
        if (response && response.length > 0) {
          console.log(response);
          this.itemsList = response; // Store all items in a list

          // Convert date fields for all items
          this.itemsList.forEach((item) => {
            item.PurchaseDate = new Date(item.PurchaseDate);
            item.WarrantyDate = new Date(item.WarrantyDate);
          });

          // Automatically select the item if only one row is returned
          if (this.itemsList.length === 1) {
            this.selectedItem = { ...this.itemsList[0] };
          } else {
            this.selectedItem = null; // Let user choose
          }
        } else {
          this.itemsList = [];
          this.selectedItem = null;
        }
      },
      (error) => {
        console.log(error);
        alert("An error occurred while fetching the order details.");
      }
    );
  };

  editItem = (item: ItemModel) => {
    this.selectedItem = { ...item }; // Clone the item for editing
  };

  updateItem = () => {
    console.log(this.selectedItem);

    this.itemService.updateItem(this.selectedItem).subscribe(
      (response) => {
        console.log(response);
        if (response) {
          this.successMessage = "הפריט עודכן בהצלחה!";
          setTimeout(() => {
            this.successMessage = "";
          }, 3000); // Hide message after 3 seconds
        }
      },
      (error) => {
        console.log(error);
        this.errorMessage = "משהו השתבש, הפריט לא עודכן.";
        setTimeout(() => {
          this.errorMessage = "";
        }, 3000); // Hide error message after 3 seconds
      }
    );
  };

  // Function to set selected item
  selectItem = (item: ItemModel) => {
    this.selectedItem = { ...item }; // Clone to avoid modifying table data directly
  };

  deleteItem = (item: ItemModel) => {
    console.log("delete itemId:", item.Id);

    this.itemService.deleteItem(item.Id).subscribe(
      (response) => {
        console.log(response);

        // Show success message
        this.successMessage = "הפריט נמחק בהצלחה"; // This is your success message in Hebrew

        this.getAllItems();

        this.getOrderDetails(this.orderNumber);

        setTimeout(() => {
          this.successMessage = ""; // Clear the message
        }, 3000); // 30 seconds in milliseconds
      },
      (error) => {
        console.log(error);
      }
    );
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/update-item/update-item.component.ts